import Axios from 'axios';
import ApiUtils from './api-utils';
import { pickBy } from 'lodash';

export default {
  getReferentiel: (numTiers) => ApiUtils.responseParser(Axios.get('/web/v1/referentiel?numTiers=' + numTiers)),
  getParametresCommande: (numArticle, numTiers, numLot) => {
    const params = pickBy({ numArticle, numTiers, numLot }, i => i !== undefined && i !== null);
    return ApiUtils.responseParser(Axios.get('/web/v1/referentiel/parametres-commande', { params }));
  }
};
